module.exports = __webpack_public_path__ + "static/media/member2.fe147b2e.jpg";